import { type ReactNode } from 'react';
import { Camera, Lock } from 'lucide-react';

const FRAME =
  'aspect-[9/16] w-40 rounded-lg ring-2 ring-brand-red/70 transition-all hover:ring-brand-red';
const FRAME_LOCKED =
  'aspect-[9/16] w-40 cursor-default overflow-hidden rounded-lg ring-2 ring-text-tertiary/40';

function Placeholder(): ReactNode {
  return (
    <div className={`${FRAME} flex items-center justify-center bg-surface`}>
      <Camera size={28} className="text-brand-red" />
    </div>
  );
}

function Preview({ src }: { src: string }): ReactNode {
  return <img src={src} alt="Preview" className={`${FRAME} object-cover`} />;
}

function LockedPreview({ src }: { src: string }): ReactNode {
  return (
    <div className={`relative ${FRAME_LOCKED}`}>
      <img
        src={src}
        alt="Foto verificada"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute right-sm top-sm rounded-full bg-surface/80 p-xs backdrop-blur">
        <Lock size={14} className="text-text-tertiary" />
      </div>
    </div>
  );
}

type Props = {
  preview: string | null;
  disabled: boolean;
  onClick: () => void;
  lockedUrl: string | null;
};

export function PhotoTrigger(p: Props): ReactNode {
  if (p.lockedUrl) return <LockedPreview src={p.lockedUrl} />;
  return (
    <button
      type="button"
      onClick={p.onClick}
      disabled={p.disabled}
      className="group focus:outline-none disabled:cursor-not-allowed disabled:opacity-40"
    >
      {p.preview ? <Preview src={p.preview} /> : <Placeholder />}
    </button>
  );
}
